gameData = {};
game = (function () {
  var _gameName = "Diamond Miner DuoMax";
  var _gameVersionMajor = "1";
  var _gameVersionMinor = "0";
  var _gameVersionBugFix = "82";
  let _gameReleaseDate = "02/08/2025";

  ///////////////////////
  // Developer options //
  ///////////////////////

  Reflex.enableDeveloperMode();
  //Reflex.developerModeData.checkUnusuedResources = true;
  // Reflex.developerModeData.useLogFiles= true;
  // Reflex.developerModeData.logFileIP= "192.168.1.106";
  // Reflex.developerModeData.highlightTranslatedText = true;
  //Reflex.developerModeData.canBreakInjectorRules = true;
  //Reflex.developerModeData.createTestLanguages = true;
  //Reflex.developerModeData.showButtonHitAreas = true;
  // bowser.mobile = true;

  ///////////////////////
  ///////////////////////

  gameData.gameVersionMajor = _gameVersionMajor;
  gameData.gameVersionMinor = _gameVersionMinor;
  gameData.gameVersionBugFix = _gameVersionBugFix;
  gameData.gameReleaseDate = _gameReleaseDate;

  function createVersion() {
    var versionString =
      _gameName +
      " v" +
      _gameVersionMajor +
      "." +
      _gameVersionMinor +
      "." +
      _gameVersionBugFix;
    console.log(versionString);
  }

  function initialise(gameConfigTask) {
    gameData.gameConfig = gameConfigTask.data;

    createVersion();
    gameData.expandIndices = {
      top: 0,
      bottom: 8,
    };
    gameData.contractIndices = {
      top: 5,
      bottom: 8,
    };
  }

  function onModal() {}

  function dimAllSymbols(dim, tint) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, tint);
    }
  }

  function onCloseTutorial() {
    resourceManager.getContainer("splashContainer").visible = false;
    resourceManager.getContainer("loadingContainer").visible = false;

    resourceManager.getContainer("backgroundContainer").visible = true;
    resourceManager.getContainer("minerContainer").visible = true;

    gameData.winningsText = resourceManager.get("slotContainer:winningsText");

    AllWaysPayWinAnimator.initialise();

    game.loadingBackgroundLandscape = resourceManager.get("splashBackgroundL");
    game.loadingBackgroundLandscape.clearInteractiveCallbacks();

    game.loadingBackgroundPortrait = resourceManager.get("splashBackgroundP");
    game.loadingBackgroundPortrait.clearInteractiveCallbacks();

    if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
      gdk.requestFullscreen();
    }

    if (gdk.deviceInfo.chrome && gdk.deviceInfo.android) {
      var chromeVersion = Number(
        String(gdk.deviceInfo.version).substring(
          0,
          String(gdk.deviceInfo.version).indexOf(".")
        )
      );
      if (chromeVersion >= 55) {
        // Chrome will only start audio on a touch
        Howler.ctx.resume();
      }
    }

    // Set up character either behind or in front of message bar
    gameData.gameContainer = resourceManager.getContainer("gameContainer");

    resourceManager.getContainer("loadingContainer").visible = false;
    resourceManager.getContainer("gameContainer").visible = true;
    resourceManager.getContainer("msgBoxPopupContainer").visible = true;
    resourceManager.getContainer("gameButtonContainer").visible = true;
    resourceManager.getContainer("particleContainer").visible = true;
    resourceManager.getContainer("helpPages").visible = true;
    resourceManager.getContainer("buyABonusContainer").visible = true;
    resourceManager.getContainer("settingsMenuContainer").visible = true;

    gameData.inputOverlord.setState("enabled");

    gameController.initialise();
  }

  function enableEncore(enabled) {
    gameData.encoreEnabled = enabled;
  }

  function blurGame(enable, value) {
    if (resourceManager.selectedAssetResolution.name === "standard") {
      value = checkForDefined(value) ? value : 1;
      resourceManager.getContainer("gameContainer").filters = enable
        ? [new PIXI.filters.BlurFilter(value)]
        : [];
      resourceManager.getContainer("gameButtonContainer").filters = enable
        ? [new PIXI.filters.BlurFilter(value)]
        : [];
    }
  }

  function changeStake(selectedStake, bpl) {
    gameData.stakeMeter.set(selectedStake);
    gdk.playerChangedStake(selectedStake);
  }

  function resetWinnings() {
    gameData.winningsMeter.set(0);
  }

  function creditChanged(creditTask) {
    gameData.creditMeter.set(creditTask.data.balance);
  }

  function onLoaded(loader, res) {
    setupPerformanceDependentObjects();
  }

  function goToSplash() {
    var loadingData = gdk.getPlatformLoadingData();
  }

  function onReady() {
    var numSymbols = Object.keys(
      resourceManager.getConfiguration().symbols
    ).length;

    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
    for (var i = 0; i < numSymbols; ++i) {
      slotMachine.symbolCreationCallbacks[i.toString()] =
        helper.getSymbolChildrenDescriptions;
    }

    for (var i = 0; i < 5; i++) {
      slotMachine.reels[i].setAnySymbolCreatedCallback(
        helper.symbolCreationCallback
      );
    }

    Reflex.deregisterEventHandler("ready", onReady);
  }

  var game = {};

  Object.defineProperties(game, {
    enableEncore: {
      value: enableEncore,
    },
    onCloseTutorial: {
      value: onCloseTutorial,
    },
    initialise: {
      value: initialise,
    },
    blurGame: {
      value: blurGame,
    },
    changeStake: {
      value: changeStake,
    },
    resetWinnings: {
      value: resetWinnings,
    },
    dimAllSymbols: {
      value: dimAllSymbols,
    },

    goToSplash: {
      value: goToSplash,
    },
  });

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe("common:BalanceEvent", creditChanged);
  messageBus.subscribe("stake:stakeChanged", changeStake);
  messageBus.subscribe("game:modal", onModal);
  Reflex.registerEventHandler("ready", onReady);

  return game;
})();
